import { memo } from 'react';

import cn from 'classnames';

import cls from './progress.module.css';

interface ProgressProps {
    value: number;
    variant?: 'blue' | 'green' | 'red';
    suffix?: string;
}

export const Progress = memo(
    ({ value, variant = 'blue', suffix }: ProgressProps) => {
        const roundedValue = Number(value.toFixed(2));

        return (
            <div className={cls.root}>
                <span
                    className={cn(cls.progress, cls[variant])}
                    style={{ width: `${Math.abs(roundedValue)}%` }}
                />
                <span className={cls.value}>
                    {roundedValue} % {suffix}
                </span>
            </div>
        );
    },
);

Progress.displayName = 'Progress';
